var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { AppSettingsStore } from '../../providers/appSettings';
import { useAuthorization } from '../../providers/authorization';
import { useApiErrorHandler } from '../../providers/apiErrorHandler';
import { useSession } from '../../providers/session';
import { makeApiCall } from '../../utils/queryApi';
import { getApiResponseData, getFailureRedirectUrl, getUnknownErrorResponse, handleApiResponse, handleErrorCallback, handleSuccessCallback, } from './utils';
export function useBasicQuery(props) {
    var _a;
    const appSettings = useContext(AppSettingsStore);
    const { getAuthToken } = useAuthorization();
    const { token } = useSession();
    const { raiseError } = useApiErrorHandler();
    let response;
    return useQuery(props.queryId, () => __awaiter(this, void 0, void 0, function* () {
        response = yield makeApiCall({
            authToken: props.authToken || token || getAuthToken(),
            request: {
                url: props.baseUrl
                    ? `${props.baseUrl}/${props.apiRoute}`
                    : `${appSettings.state.apiBaseUrl}/${props.apiRoute}`,
                httpMethod: props.httpMethod,
                form: props.isFormData,
                body: props.body,
            },
        });
        const redirectUrl = getFailureRedirectUrl(response, appSettings === null || appSettings === void 0 ? void 0 : appSettings.state, props === null || props === void 0 ? void 0 : props.redirectUrlMap);
        if (redirectUrl && props.onRedirect) {
            props.onRedirect(redirectUrl);
        }
        // Report error to ApiErrorHandlerProvider
        if (response.status >= 300) {
            if (!props.preventApiErrorPropagation)
                raiseError(response);
        }
        const res = yield handleApiResponse(response);
        return getApiResponseData(res);
    }), Object.assign({ enabled: (_a = props === null || props === void 0 ? void 0 : props.params) === null || _a === void 0 ? void 0 : _a.enabled, onSuccess: handleSuccessCallback(props === null || props === void 0 ? void 0 : props.params), onError: (error) => {
            if (!props.preventApiErrorPropagation)
                raiseError(response || getUnknownErrorResponse(error));
            handleErrorCallback(props === null || props === void 0 ? void 0 : props.params, error);
        } }, props.queryOptions));
}
//# sourceMappingURL=basicQuery.js.map